module.exports = __webpack_public_path__ + "img/icon-car-w.92229f48.svg";